import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    selector: 'app-help-options',
    templateUrl: './help-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./help-options.component.scss']
})
export class HelpOptionsComponent {
    @Input() public notRedirect: boolean = false;
    @Input() public elementsHelpOptions: { [key: string]: string } = {
        alt: '',
        title: '',
        imageUrl: '',
        titleCard: '',
        linkCard: '',
        description: ''
    };
    public constructor(private router: Router) {}

    public redirectTo(url: string): void {
        if (!url) {
            return;
        }
        if (this.elementsHelpOptions.linkCard?.includes('https://')) {
            window.open(url, 'blank');

            return;
        }
        this.router.navigateByUrl(this.elementsHelpOptions.linkCard ?? '');
    }
}
